<template>
    <div class="bax-alert-message d-md-flex">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'VueAlert',
};
</script>
